import { createElement } from 'react';
import { jsxs, jsx } from 'react/jsx-runtime';
import { Row, Col, CustomLink, SubTitle, Body, styled } from '@teko/ds-desktop';
import { B as BlockHeader } from './BlockHeader-4332d564.js';
import { E as EnhancedImage } from './EnhancedImage-5956213c.js';

const PromoteBlock = ({ header, contentItems, bottomImages, banner, }) => {
    return (jsxs(Block, { children: [jsx(BlockHeader, Object.assign({}, header), void 0), jsxs(Row, { children: [jsx(Col, Object.assign({ span: 4 }, { children: jsx(EnhancedImage, Object.assign({ hover: "zoom", googleImageParams: { width: 400 }, height: "100%", objectFit: "cover" }, banner), void 0) }), void 0), jsx(Col, Object.assign({ span: 8 }, { children: jsx(ContentItemsWrapper, { children: contentItems.map((item, index) => (createElement(CustomLink, Object.assign({}, item.link, { key: index }),
                                jsxs(ContentItem, { children: [jsx(SubTitle, Object.assign({ level: 2, line: 1 }, { children: item.name }), void 0), jsx(Body, Object.assign({ level: 1, marginBottom: "s24", line: 1 }, { children: item.description }), void 0), jsx(EnhancedImage, Object.assign({ hover: "zoom", googleImageParams: {
                                                width: 300,
                                            }, height: "94px", objectFit: "contain" }, item.image), void 0)] }, index)))) }, void 0) }), void 0)] }, void 0), bottomImages && (jsx(Footer, { children: bottomImages.map((item, index) => (jsx(EnhancedImage, Object.assign({ hover: "zoom", height: "68px", googleImageParams: { width: 200 }, objectFit: "contain" }, item), index))) }, void 0))] }, void 0));
};
const ContentItemsWrapper = styled(Col) `
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 1px;
  background-color: #e0e0e0;
`;
const ContentItem = styled.div(({ theme }) => `
  text-align: center;
  padding: 1rem;
  background-color: ${theme.colors.white};
  height: 100%;
  &:hover {
    color: ${theme.colors.primary500};
  }
`);
const Block = styled.div `
  background: white;
  border-radius: 8px;
  overflow: hidden;
`;
const Footer = styled.div `
  display: flex;
  justify-content: space-between;
`;

export { PromoteBlock as P };
